// pages/NotFound.jsx
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      className="container py-5 d-flex align-items-center justify-content-center"
      style={{ minHeight: "60vh" }}
    >
      <div className="text-center">
        <div className="display-4 fw-bold">404</div>
        <p className="text-muted mt-2 mb-4">
          Oops! The page you’re looking for doesn’t exist or has moved.
        </p>
        <Link to="/" className="btn btn-primary rounded-3">
          Go Home
        </Link>
      </div>
    </div>
  );
}
